import {React} from 'common'
import IconButton from '@mui/material/IconButton'
import MenuIcon from '@mui/icons-material/Menu'

const MainMenuButton = ({toggleDrawer}) => {
    return (
        <IconButton color="primary" edge="start" onClick={toggleDrawer}>
            <MenuIcon />
        </IconButton>
    )
}

export default MainMenuButton
